import React, { useContext, useEffect, useRef } from 'react';
import { isEmpty } from "lodash";
import cn from 'classnames';
import { selectGroup, IndexData } from "../../../common/index-context";
import TableFivePointsScales from "../../../common/components/entity-modal/table-five-points-scales";
import TableAttributeRatings from "../../../common/components/entity-modal/table-attribute-ratings";
import TablePreference from "../../../common/components/entity-modal/table-preference";
import ComparisonsLegend from "../../../common/components/comparisons-legend";
import ShelfEvaluationTable from '../../../common/components/entity-modal/shelf-evaluation-table';
import TableCustomMetrics from '../../../common/components/entity-modal/table-custom_metrics';
import ShoppingCartPerformers from '../../../common/components/entity-modal/shopping-cart-performers';

const TableConcept = ({ data, current }) => {
  const shelfPresent = data.shelf_enabled || data.cart_exercise;

  const fivePointScales = selectGroup(data, 'five_point_scale');
  const fivePointScalesPresent = !isEmpty(fivePointScales);
  const customMetrics = selectGroup(data, 'custom_metric');
  const customMetricsPresent = !isEmpty(customMetrics);
  const attributeRatings = selectGroup(data, 'package_attribute_ratings');
  const attributeRatingsPresent = !isEmpty(attributeRatings);
  const preference = selectGroup(data, 'preference');
  const preferencePresent = !isEmpty(preference);

  const fpAcstAs = fivePointScalesPresent || customMetricsPresent || shelfPresent;
  const arAp = attributeRatingsPresent || preferencePresent;

  const tourElement = useRef(null);
  const { getTourUseEffectArgs, averageMode } = useContext(IndexData);
  const [ callback, condition ] = getTourUseEffectArgs(
    "projectModalTable",
    tourElement
  );
  useEffect(callback, condition);

  return (
    <>
      <div
        className="concept-report_tables comparisons_grid"
        ref={ tourElement }
      >
        {
          fpAcstAs &&
          <div className="comparisons_col -grow">
            <TableFivePointsScales
              data={ data }
              current={ current }
              fivePointScales={ fivePointScales }
              groupName="five_point_scale"
              className="-long-first-cell"
            />
            {
              customMetricsPresent &&
              <TableCustomMetrics
                data={ data }
                current={ current }
                customMetrics={ customMetrics }
                groupName="custom_metrics"
                className="-long-first-cell"
              />
            }
            {
              shelfPresent &&
              <ShelfEvaluationTable data={ data } current={ current } />
            }
          </div>
        }

        {
          (arAp) &&
          <div
            className={
              cn(
                "comparisons_col",
                {
                  '-grow': !fpAcstAs,
                  '-width-50': fpAcstAs
                }
              )
            }
          >
            {
              attributeRatingsPresent &&
              <TableAttributeRatings
                data={ data }
                current={ current }
                attributeRatings={ attributeRatings }
                groupName="package_attribute_ratings"
              />
            }
            {
              preferencePresent &&
              <TablePreference
                data={ data }
                current={ current }
                preference={ preference }
              />
            }
          </div>
        }
      </div>
      <ComparisonsLegend
        forModal
        averageMode={ averageMode }
        statTesting={ data.stat_testing }
      />

      {data.cart_exercise && <ShoppingCartPerformers data={ data } current={ current } />}
    </>
  );
};

export default TableConcept;
